import React from 'react';
import classNames from "classnames/bind"

import styles from "./footer.module.scss"

const cx = classNames.bind(styles)

export const Footer = () => {
    const fullYear = new Date().getFullYear();

    return (
      <footer className={cx(["animate__animated", "animate__fadeIn", "animate__delay-2s"])}>
        <div className={cx('container')}>
            <p className={cx(['copyright'])}>&copy;{fullYear} Justin Ashley</p>
        </div>
      </footer>
    )
}